<template>
<vx-card title="Asesores">
    <vs-table pagination max-items="10" stripe search :data="asesores">
        <template slot="header">
            <vs-button @click="addAdviser()">Agregar</vs-button>
        </template>

        <template slot="thead">
            <vs-th sort-key="nombres"></vs-th>
            <vs-th sort-key="nombres">Nombres</vs-th>
            <vs-th sort-key="phone">Teléfono</vs-th>
            <vs-th sort-key="email">Correo</vs-th>
            <vs-th sort-key="rol">Rol</vs-th>
            <vs-th sort-key="status">Estado</vs-th>
        </template>

        <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td>
                    <vs-avatar :text="tr.adv_nombres+' '+tr.adv_apellidos" />
                </vs-td>

                <vs-td>
                    {{ tr.adv_nombres }} {{ tr.adv_apellidos }}
                </vs-td>

                <vs-td :data="tr.phone">
                    {{ tr.adv_phone }}
                </vs-td>

                <vs-td :data="tr.adv_email">
                    {{ tr.adv_email }}
                </vs-td>

                <vs-td :data="tr.adv_rol">
                    <vs-chip v-if="tr.adv_rol == 1" color="success">
                        <vs-avatar />
                        Admin
                    </vs-chip>
                    <vs-chip v-if="tr.adv_rol == 2" color="warning">
                        <vs-avatar />
                        Asesor
                    </vs-chip>
                </vs-td>

                <vs-td :data="tr.status">
                    <vs-switch color="success" v-model="tr.adv_status">
                        <span slot="on">Activo</span>
                        <span slot="off">Off</span>
                    </vs-switch>
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
</vx-card>
</template>

<script>
import vSelect from 'vue-select'
import advisers from '@/services/asesores'
export default {
    components: {
        'v-select': vSelect,
    },
    data() {
        return {
            asesores: [],
            roles: [{
                    'rol_id': '1',
                    'rol_nombre': 'admin'
                },
                {
                    'rol_id': '2',
                    'rol_nombre': 'asesor'
                },
            ]
        }
    },
    mounted() {
        this.getAsesores()
    },
    methods: {
        addAdviser() {
            console.log('new')
            const menu = {
                list: false,
                new: true
            }
            this.$emit('item', menu)
        },
        async getAsesores() {
            try {
                let {
                    data
                } = await advisers()
                this.asesores = data
            } catch (error) {
                console.log(error)
            }
        }
    },
}
</script>
